<template>
    <!-- 数字资产 -->
<div class="OurService" style="align-self: center;">
            <!-- 黑头 -->
    <div class="header flex-all-center">
        <p>{{ $t("ourServiceDigital.title")}}</p>
    </div>

    <div class="main">
        <div class="maincontent">
<!-- 沉浸艺术展演 -->
            <div class="textlayout">
                <div class="text">
                    <p class="flex-all-center title-2">{{ $t("ourServiceDigital.text1")}}</p>

                    <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceDigital.text2")}}</p>
                    <p class="textcontent-cn" v-else>{{ $t("ourServiceDigital.text2")}}</p>

                </div>
                <img class="img1" src="../../assets/images/OurServiceDigital_pic1.png">
            </div>
    
<!-- 虚拟乐团表演 -->
            <div class="textlayout">
                <img class="img2" src="../../assets/images/OurServiceDigital_pic2.png">
                <div class="text">
                    <p class="flex-all-center title-2">{{ $t("ourServiceDigital.text3")}}</p>

                    <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceDigital.text4")}}</p>
                    <p class="textcontent-cn" v-else>{{ $t("ourServiceDigital.text4")}}</p>

                </div>
            </div>
<!-- NPC短剧制作 -->
            <div class="textlayout">
                <div class="text">
                    <p class="flex-all-center title-2">{{ $t("ourServiceDigital.text5")}}</p>

                    <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceDigital.text6")}}</p>
                    <p class="textcontent-cn" v-else>{{ $t("ourServiceDigital.text6")}}</p>


                </div>
                <img class="img3" src="../../assets/images/OurServiceDigital_pic3.png">
            </div>
<!-- 球幕大型演出 -->
            <div class="textlayout">
                <img class="img4" src="../../assets/images/OurServiceDigital_pic4.png">
                <div class="text">
                    <p class="flex-all-center title-2">{{ $t("ourServiceDigital.text7")}}</p>

                    <p class="textcontent-en" v-if="isEn">{{ $t("ourServiceDigital.text8")}}</p>
                    <p class="textcontent-cn" v-else>{{ $t("ourServiceDigital.text8")}}</p>
 
                </div>
            </div>
        </div>
    </div>
    <div class="footer"></div>
</div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OurServiceDigital",
  computed: {
    ...mapState({
      isEn: (state) => state.isEn,
    }),
  },
  data() {
    return {
    };
  },
 
  created() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.OurService{
  color: #000;
  width: 100%;

  .header {
    height: 400px;
    background: #000;
    font-family: "OPPO-L";
    font-size: 42px;
    color: #fff;

    p{
    text-align: center;
    }
  }

  .main{
    display: flex;
    justify-content: center;

    .maincontent{
      max-width: 1200px;
      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      margin-top: 17px;
      width: 100%;

      p{
        margin-top: 17px;
      }

      .textcontent-cn{
      text-indent: 34px;
      text-align:justify;
      }

      .textcontent-en{
      text-indent: 34px;
      text-align: justify;
      }

      .textlayout{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 80px;

        .title-2{
          font-family: "OPPO-B";
          font-size: 22px;
          color: #000;
        }

        .text{
          width: 544px;
        }

        .img1{
        width: 600px;
        height: auto;
        margin-left: 100px;

        }
        .img2{
        width: 600px;
        height: auto;
        margin-right: 100px;
        }

        .img3{
        width: 600px;
        height: auto;
        margin-left: 100px;
        }

        .img4{
        width: 600px;
        height: auto;
        margin-right: 100px;
        }
      }
    }
    .footer{
      margin-top: 120px;
    }
  }
}







@media (max-width: 768px) {
.OurService{
  color: #000;
  width: 100%;

  .header {
    height: 400px;
    background: #000;
    font-family: "OPPO-L";
    font-size: 42px;
    color: #fff;

    p{
    text-align: center;
    }
  }

  .main{
    display: flex;
    justify-content: center;

    .maincontent{
      max-width: 1200px;
      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      margin-top: 0px;
      width: 90%;

      p{
        margin-top: 17px;
      }

      .textcontent-cn{
      text-indent: 34px;
      text-align:justify;
      }

      .textcontent-en
      {
      text-indent: 34px;
      text-align: justify;
      }

      .textlayout
      {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        margin-top: 40px;

        .title-2
        {
          text-align: center;
          font-family: "OPPO-B";
          font-size: 22px;
          color: #000;
        }
        .text{
          width: 100%;
        }

        .img1{
        width:90%;
        height: auto;
        margin-left: 0px;
        margin-top: 40px;
        }

        .img2{
        width: 90%;
        height: auto;
        margin-right: 0px;

        }
        .img3{
        width:90%;
        height: auto;
        margin-left: 0px;
        margin-top: 40px;

        }
        .img4{
        width: 90%;
        height: auto;
        margin-right: 0px;
        }
      }
    }

  }
  .footer{
      margin-top: 40px;
  }
}

}

</style>
